// src/features/auth/queries/authQueries.ts
import { useQuery } from '@tanstack/react-query';
import type { User } from 'firebase/auth';
import { auth } from '../../../lib/firebase';

export const authQueryKeys = {
  all: ['auth'] as const,
  user: () => ['auth', 'user'] as const,
  // ユーザー依存のキーは uid を含める（未ログイン時は 'anon'）
  userWorkspaces: (uid?: string) => ['auth', 'userWorkspaces', uid ?? 'anon'] as const,
  workspaceAccess: (workspaceId: string, uid?: string) =>
    ['auth', 'workspaceAccess', workspaceId, uid ?? 'anon'] as const,
  // ワークスペースメンバー一覧のクエリキー
  workspaceMembers: (workspaceId: string) => ['auth', 'workspaceMembers', workspaceId] as const,
} as const;

/**
 * 認証状態を取得するクエリフック
 * ここでは購読しない（購読は AuthProvider に集約）。
 * 値は Provider からの setQueryData により更新される。
 */
export const useAuthQuery = () => {
  return useQuery<User | null>({
    queryKey: authQueryKeys.user(),
    // 現在の認証状態を即時返す。初期表示は null の可能性があるが、
    // AuthProvider 側の onAuthStateChanged により直後に更新される。
    queryFn: async () => (auth ? auth.currentUser : null),
    initialData: auth ? auth.currentUser : null, // 初期描画時の「一瞬null→即更新」を防ぐ
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });
};

